module.exports = __webpack_public_path__ + "img/logo_new.a16ce974.svg";